import Vue from 'vue'
// import Router from 'vue-router'
import Layout from '@/view/layout'
import {
  dynamicRouterAdd
} from '@/libs/router-util' // ①添 引入加载菜单

// Vue.use(Router)
// 不作为Main组件的子页面展示的页面单独写
export const otherRouter = [{
  path: '/login', //登陆
  name: 'login',
  component: resolve => require(['@/view/login/login.vue'], resolve),
    meta: {
      title: ''
    }
  },
  {
    path: '/index', 
    name: 'index',
    component: resolve => require(['@/view/index/index.vue'], resolve),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/dataBrain',
    name: 'dataBrain',
    component: resolve => require(['@/view/main/dataBrain.vue'], resolve),
    meta: {
      title: '数据大脑'
    }
  }
]

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在mainRouter里
export const mainRouter = [{
  path: '/',
  component: Layout, //整体页面的布局
  children: [{
      path: 'main',
      name: 'main',
      component: resolve => require(['@/view/main/main.vue'], resolve),
      meta: {
        title: '阿中分析系统'
      }
    },
    {
      path: 'productABC',
      name: 'productABC',
      component: resolve => require(['@/view/main/productABC.vue'], resolve),
      meta: {
        title: '商品ABC'
      }
    },
    {
      path: 'dispatchCenter',
      name: 'dispatchCenter',
      component: resolve => require(['@/view/main/dispatchCenter.vue'], resolve),
      meta: {
        title: '调度中心'
      }
    },
    {
      path: 'priceAnalysis',
      name: 'priceAnalysis',
      component: resolve => require(['@/view/main/priceAnalysis.vue'], resolve),
      meta: {
        title: '价格带分析'
      }
    },
    {
      path: 'timeSaleAnalysis',
      name: 'timeSaleAnalysis',
      component: resolve => require(['@/view/main/timeSaleAnalysis.vue'], resolve),
      meta: {
        title: '时间段分析'
      }
    },
    {
      path: 'passflowAnalysis',
      name: 'passflowAnalysis',
      component: resolve => require(['@/view/main/passflowAnalysis.vue'], resolve),
      meta: {
        title: '人脸客流分析'
      }
    } 
    
  ]
}
]
// const routers = new Router({
//   mode: 'history',
//   routes: [{
//       path: '/login', //登陆
//       name: 'login',
//       component: resolve => require(['@/view/login/login.vue'], resolve),
//       meta: {
//         title: ''
//       }
//     },
//     {
//       path: '/index', 
//       name: 'index',
//       component: resolve => require(['@/view/index/index.vue'], resolve),
//       meta: {
//         title: '首页'
//       }
//     },
//     {
//       path: '/dataBrain',
//       name: 'dataBrain',
//       component: resolve => require(['@/view/main/dataBrain.vue'], resolve),
//       meta: {
//         title: '数据大脑'
//       }
//     },
//     {
//       path: '/',
//       component: Layout, //整体页面的布局
//       children: [{
//           path: 'main',
//           name: 'main',
//           component: resolve => require(['@/view/main/main.vue'], resolve),
//           meta: {
//             title: '阿中分析系统'
//           }
//         },
//         {
//           path: 'productABC',
//           name: 'productABC',
//           component: resolve => require(['@/view/main/productABC.vue'], resolve),
//           meta: {
//             title: '商品ABC'
//           }
//         },
//         {
//           path: 'dispatchCenter',
//           name: 'dispatchCenter',
//           component: resolve => require(['@/view/main/dispatchCenter.vue'], resolve),
//           meta: {
//             title: '调度中心'
//           }
//         },
//         {
//           path: 'priceAnalysis',
//           name: 'priceAnalysis',
//           component: resolve => require(['@/view/main/priceAnalysis.vue'], resolve),
//           meta: {
//             title: '价格带分析'
//           }
//         },
//         {
//           path: 'timeSaleAnalysis',
//           name: 'timeSaleAnalysis',
//           component: resolve => require(['@/view/main/timeSaleAnalysis.vue'], resolve),
//           meta: {
//             title: '时间段分析'
//           }
//         },
//         {
//           path: 'passflowAnalysis',
//           name: 'passflowAnalysis',
//           component: resolve => require(['@/view/main/passflowAnalysis.vue'], resolve),
//           meta: {
//             title: '人脸客流分析'
//           }
//         }
//       ]
//     }
//   ],
//   scrollBehavior(to, from, savedPosition) {
//     if (savedPosition) {
//       return savedPosition
//     } else {
//       return {
//         x: 0,
//         y: 0
//       }
//     }
//   }
// });
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [...dynamicRouterAdd()]
export const routes = [
  ...otherRouter,
  ...mainRouter,
  ...appRouter
]
export default routes;



// WEBPACK FOOTER //
// ./src/router/routers.js